import React from 'react';
import './Skills.css';
import { Container } from 'react-bootstrap';

const Skills = () => {
    return (
        <Container>
            <div>
                <h4 id='top' className="text-primary text-center mt-3 animate__animated animate__zoomIn">I'm an expert on the below technology</h4>
                <div className="skills animate__animated animate__fadeInUp">
                    <div className="border p-2 mx-2 rounded skills2">HTML5</div>
                    <div className="border p-2 mx-2 rounded skills2">CSS3</div>
                    <div className="border p-2 mx-2 rounded skills2">Bootstrap5</div>
                    <div className="border p-2 mx-2 rounded skills2">Tailwind CSS</div>
                    <div className="border p-2 mx-2 rounded skills2">Material UI</div>
                    <div className="border p-2 mx-2 rounded skills2">JavaScript(ES6)</div>
                    <div className="border p-2 mx-2 rounded skills2">React.js</div>
                    <div className="border p-2 mx-2 rounded skills2">React Hooks</div>
                    <div className="border p-2 mx-2 rounded skills2">React Router</div>
                    <div className="border p-2 mx-2 rounded skills2">Context API</div>
                    <div className="border p-2 mx-2 rounded skills2">Express.js</div>
                    <div className="border p-2 mx-2 rounded skills2">Node.js</div>
                    <div className="border p-2 mx-2 rounded skills2">NPM</div>
                    <div className="border p-2 mx-2 rounded skills2">Regular Expression</div>
                    <div className="border p-2 mx-2 rounded skills2">Redux</div>
                    <div className="border p-2 mx-2 rounded skills2">Axios</div>
                    <div className="border p-2 mx-2 rounded skills2">Git</div>
                    <div className="border p-2 mx-2 rounded skills2">GitHub</div>
                    <div className="border p-2 mx-2 rounded skills2">REST APIs</div>
                    <div className="border p-2 mx-2 rounded skills2">JSON</div>
                    <div className="border p-2 mx-2 rounded skills2">JSON Web Token (JWT)</div>
                    <div className="border p-2 mx-2 rounded skills2">Google Map</div>
                    <div className="border p-2 mx-2 rounded skills2">Stripe</div>
                    <div className="border p-2 mx-2 rounded skills2">Figma</div>
                    <div className="border p-2 mx-2 rounded skills2">Heroku</div>
                    <div className="border p-2 mx-2 rounded skills2">Netlify</div>
                    <div className="border p-2 mx-2 rounded skills2">Vercel</div>
                    <div className="border p-2 mx-2 rounded skills2">Firebase</div>
                    <div className="border p-2 mx-2 rounded skills2">Visual Studio Code</div>
                    <div className="border p-2 mx-2 rounded skills2">Chrome dev tools</div>
                    <div className="border p-2 mx-2 rounded skills2">Tomcat</div>
                    <div className="border p-2 mx-2 rounded skills2">VMware</div>
                    <div className="border p-2 mx-2 rounded skills2">MongoDB</div>
                    <div className="border p-2 mx-2 rounded skills2">Programming in C</div>
                    <div className="border p-2 mx-2 rounded skills2">Basic Java</div>
                    <div className="border p-2 mx-2 rounded skills2">Oracle Database 11g SQL</div>
                    <div className="border p-2 mx-2 rounded skills2">Oracle Database 11g PL/SQL</div>
                    <div className="border p-2 mx-2 rounded skills2">Oracle Application Express (Apex)</div>
                    <div className="border p-2 mx-2 rounded skills2">Jasper Reports</div>
                    <div className="border p-2 mx-2 rounded skills2">Windows Server 2008, 2012 R2</div>
                    <div className="border p-2 mx-2 rounded skills2">Linux Server 6.4</div>
                    <div className="border p-2 mx-2 rounded skills2">Data Privacy</div>
                </div>
            </div>
        </Container>
    );
};

export default Skills;